module.exports = __webpack_public_path__ + "static/media/6195.1debf4a4.jpg";